var map = {
	"./01/index.scss": "./blocks/01/index.scss",
	"./02/index.scss": "./blocks/02/index.scss",
	"./03/index.scss": "./blocks/03/index.scss",
	"./04/index.scss": "./blocks/04/index.scss",
	"./05/index.scss": "./blocks/05/index.scss",
	"./06/index.scss": "./blocks/06/index.scss",
	"./block-myths/index.scss": "./blocks/block-myths/index.scss",
	"./compare/index.scss": "./blocks/compare/index.scss",
	"./doctors/index.scss": "./blocks/doctors/index.scss",
	"./faq/index.scss": "./blocks/faq/index.scss",
	"./form-01/index.scss": "./blocks/form-01/index.scss",
	"./form-02/index.scss": "./blocks/form-02/index.scss",
	"./hero/index.scss": "./blocks/hero/index.scss",
	"./map/index.scss": "./blocks/map/index.scss",
	"./price/index.scss": "./blocks/price/index.scss",
	"./stages/index.scss": "./blocks/stages/index.scss",
	"./steps/index.scss": "./blocks/steps/index.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive \\.scss$";